import { getAuth } from "firebase/auth";
import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import ErrorMessage from "./ErrorMessage.js";
import LoginButton from "./LoginButton.js";
import LoginInput from "./LoginInput.js";

export default function Login({ callback, uid }) {
  const [isLogged, setLogged] = useState(uid !== null);
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const auth = getAuth();

  if (!isLogged) {
    return (
      <main>
        <div className="container">
          <div className="card">
            <div className="card-body">
              <h1 className="card-title text-center">Log Into Your Account</h1>
              <form>
                <ErrorMessage errorMessage={errorMessage} />
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <LoginInput type="email" callback={setEmail} id="email" />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <LoginInput
                    type="password"
                    callback={setPassword}
                    id="password"
                  />
                </div>
                <div className="login-Forgot">
                  <LoginButton
                    setErrorMessage={setErrorMessage}
                    auth={auth}
                    email={email}
                    password={password}
                    callback={callback}
                    setLogged={setLogged}
                  />
                </div>
              </form>
              <hr />
              <p>
                Don't have an account? <Link to="/register">Register</Link>{" "}
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  } else {
    return <Navigate to={"/profile/" + uid} />;
  }
}
